import * as _4 from 'lodash4';

import { ICommand } from 'core-ts-types';
import { CommunicatorService } from 'ui-ng-component-communicator';

class RegistrationTermPin {
  private buttonText = 'Save';
  private open = false;
  private shouldContinueAfterTermPinSave = false;
  private openTermPinDialogBound = this.openTermPinDialog.bind(this);
  private openTermPinDialogBeforeRegistrationBound = this.openTermPinDialogBeforeRegistration.bind(this);

  constructor(
    private $stateParams: ng.ui.IStateParamsService,
    private ngComponentCommunicatorService: CommunicatorService,
    private saveTermPinCommand: ICommand,
    private phxNotificationDelegate: any,
    private log: any
  ) {}
  $onInit() {
    this.ngComponentCommunicatorService.subscribe('OPEN_TERM_PIN_MODAL', this.openTermPinDialogBound);
    this.ngComponentCommunicatorService.subscribe(
      'OPEN_TERM_PIN_MODAL_BEFORE_REGISTRATION',
      this.openTermPinDialogBeforeRegistrationBound
    );
    this.initialize();
  }
  initialize() {
    this.shouldContinueAfterTermPinSave = false;
    this.buttonText = 'Save';
  }
  closeDialog() {
    this.initialize();
    this.open = false;
  }
  openedChanged($event: any) {
    if ($event && $event.detail && !$event.detail.value) {
      this.closeDialog();
    }
  }
  openTermPinDialog() {
    this.initialize();
    this.open = true;
  }
  openTermPinDialogBeforeRegistration() {
    this.shouldContinueAfterTermPinSave = true;
    this.buttonText = 'Continue';
    this.open = true;
  }
  saveTermPinAndContinue() {
    if (this.shouldContinueAfterTermPinSave) {
      this.ngComponentCommunicatorService.publish('SAVE_TERM_PIN_AND_CONTINUE');
    } else {
      this.saveTermPinCommand(this.$stateParams.termId)
        .then(() => {
          const config = {
            content: `Term pin saved.`,
            showIcon: true,
            status: 'success',
            dismissButton: true
          };
          this.phxNotificationDelegate.restrictTo('reg-alerts').create(config);
        })
        .catch((e) => {
          this.phxNotificationDelegate.restrictTo('reg-alerts').error(`Failed to save the Term PIN`);
          this.log.issue(e);
        });
    }
    this.closeDialog();
  }
}

class RegistrationTermPinComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {};
    this.controller = RegistrationTermPin;
    this.templateUrl =
      'capability-ng-scheduler/src/views/registration/components/registration_term_pin/registration_term_pin_component.html';
  }
}
angular.module('capability-ng-scheduler').component('registrationTermPin', new RegistrationTermPinComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_term_pin/registration_term_pin_component.ts